/* global InputNotifier, ajaxHelper */

if (!window.AdressCheck) {
	window.AdressCheck = (function () {
		// ReSharper disable once InconsistentNaming
		let AdressCheck = function (
			liefereStrassenUrl,
			liefereOrteUrl,
			lieferePLZsUrl,
			adresseGueltigUrl,
			selectorWarnung,
			selectorStrasse,
			selectorHausnummer,
			selectorOrt,
			selectorPLZ,
			abXZeichen,
			selectorVorwahl
		) {
			this.liefereStrassenUrl = liefereStrassenUrl;
			this.liefereOrteUrl = liefereOrteUrl;
			this.lieferePLZsUrl = lieferePLZsUrl;
			this.adresseGueltigUrl = adresseGueltigUrl;
			this.selectorWarnung = selectorWarnung;
			const flags = {
				NotifyBlur: true,
			};
			this.eingabeFeldStrasse = new InputNotifier($.extend(flags, { Id: selectorStrasse.substr(1) }));
			this.eingabeFeldHausnummer = new InputNotifier($.extend(flags, { Id: selectorHausnummer.substr(1) }));
			this.eingabeFeldPLZ = new InputNotifier($.extend(flags, { Id: selectorPLZ.substr(1) }));
			this.eingabeFeldOrt = new InputNotifier($.extend(flags, { Id: selectorOrt.substr(1) }));
			if (selectorVorwahl) {
				this.eingabeFeldVorwahl = new InputNotifier($.extend(flags, { Id: selectorVorwahl.substr(1) }));
			}
			this.abXZeichen = abXZeichen;
			this.registerAutoCompleteStrasse();
			this.registerAutoCompletePLZNachHausnummer();
			this.registerAutoCompletePLZ();
			this.registerAutoCompleteOrt();
			this.registerAdresseGueltig();
		};

		AdressCheck.prototype.registerAutoCompleteStrasse = function () {
			const self = this;
			this.eingabeFeldStrasse.$().autocomplete({
				messages: {
					noResults: 'Keine passende Strasse in unseren Daten gefunden.',
					results: anzahl =>
						`${anzahl === 1 ? 'Eine' : anzahl} passende ${anzahl > 1 ? 'Strassen' : 'Strasse'} gefunden, verwenden Sie Pfeil hoch und runter um durch die Auswahl zu navigieren.`,
				},
				select: function (_, ui) {
					this.value = ui.item.value.Strasse;
					self.eingabeFeldOrt.val(ui.item.value.Ort);
					self.eingabeFeldPLZ.val(ui.item.value.PLZ);
					if (self.eingabeFeldVorwahl) {
						self.eingabeFeldVorwahl.val(ui.item.value.Vorwahl);
					}
					return false;
				},
				source: function (request, response) {
					const strasse = request.term;
					if (strasse && strasse.length > 0) {
						ajaxHelper.nurEinRequest(
							self.liefereStrassenUrl,
							{
								strasse: strasse,
								ort: self.eingabeFeldOrt.val(),
								plz: self.eingabeFeldPLZ.val(),
							},
							function (data) {
								response(
									$.map(data, function (item) {
										const label = item.Strasse + (item.Ort === null ? '' : `, ${item.Ort}`);
										item.toString = () => label;
										return {
											label,
											value: item,
										};
									})
								);
							}
						);
					}
				},
				minLength: self.abXZeichen,
			});
		};
		AdressCheck.prototype.registerAutoCompletePLZNachHausnummer = function () {
			const self = this;
			let id = null;
			$(':input').on('focus', function () {
				id = this.id;
			});
			self.eingabeFeldHausnummer.$().on('blur', function () {
				const strasse = self.eingabeFeldStrasse.val();
				const hausnummer = $(this).val();
				const ort = self.eingabeFeldOrt.val();
				if (ort == null) {
					return;
				}
				ajaxHelper.nurEinRequest(
					self.lieferePLZsUrl,
					{
						strasse: strasse,
						hausnummer: hausnummer,
						ort: ort,
					},
					function (data) {
						if (data.length === 1) {
							self.eingabeFeldPLZ.val(data[0].PLZ);
							self.eingabeFeldOrt.val(data[0].Ort);
							if (id === self.eingabeFeldPLZ.$().prop('id')) {
								self.eingabeFeldPLZ.$().trigger('select');
							}
						}
					}
				);
			});
		};
		AdressCheck.prototype.registerAutoCompletePLZ = function () {
			const self = this;
			self.eingabeFeldPLZ.$().autocomplete({
				messages: {
					noResults: 'Keine passende Postleitzahl in unseren Daten gefunden.',
					results: anzahl =>
						`${anzahl === 1 ? 'Eine' : anzahl} passende ${anzahl > 1 ? 'Postleitzahlen' : 'Postleitzahl'} gefunden, verwenden Sie Pfeil hoch und runter um durch die Auswahl zu navigieren.`,
				},
				select: function (_, ui) {
					this.value = ui.item.value.PLZ;
					self.eingabeFeldOrt.val(ui.item.value.Ort);
					if (self.eingabeFeldVorwahl) {
						self.eingabeFeldVorwahl.val(ui.item.value.Vorwahl);
					}
					return false;
				},
				source: function (request, response) {
					ajaxHelper.nurEinRequest(
						self.lieferePLZsUrl,
						{
							plz: request.term,
							strasse: self.eingabeFeldStrasse.val(),
							hausnummer: self.eingabeFeldHausnummer.val(),
							ort: self.eingabeFeldOrt.val(),
						},
						function (data) {
							response(
								$.map(data, function (item) {
									const label = `${item.PLZ} ${item.Ort}`;
									item.toString = () => label;
									return {
										label,
										value: item,
									};
								})
							);
						}
					);
				},
				minLength: self.abXZeichen,
			});
		};
		AdressCheck.prototype.registerAutoCompleteOrt = function () {
			const self = this;
			self.eingabeFeldOrt.$().autocomplete({
				messages: {
					noResults: 'Keinen passenden Ort in unseren Daten gefunden.',
					results: anzahl =>
						`${anzahl === 1 ? 'Einen passenden Ort' : `${anzahl} passende Orte`} ${anzahl > 1 ? '' : ''} gefunden, verwenden Sie Pfeil hoch und runter um durch die Auswahl zu navigieren.`,
				},
				select: function (_, ui) {
					this.value = ui.item.value.Ort;
					if (ui.item.value.PLZ != null) {
						self.eingabeFeldPLZ.val(ui.item.value.PLZ);
					}
					if (self.eingabeFeldVorwahl) {
						self.eingabeFeldVorwahl.val(ui.item.value.Vorwahl);
					}
					return false;
				},
				source: function (request, response) {
					ajaxHelper.nurEinRequest(
						self.liefereOrteUrl,
						{
							ort: request.term,
							strasse: self.eingabeFeldStrasse.val(),
							hausnummer: self.eingabeFeldHausnummer.val(),
						},
						function (data) {
							response(
								$.map(data, function (item) {
									const label = item.Ort + (item.PLZ === null ? '' : `, ${item.PLZ}`);
									item.toString = () => label;
									return {
										label,
										value: item,
									};
								})
							);
						}
					);
				},
				minLength: self.abXZeichen,
			});
		};

		AdressCheck.prototype.registerAdresseGueltig = function () {
			const self = this;
			const adresseGueltigMitTimer = function (geaendert, quelle) {
				if (adresseGueltigMitTimer.Timer) {
					window.clearTimeout(adresseGueltigMitTimer.Timer);
					adresseGueltigMitTimer.Timer = undefined;
				}
				const strasse = self.eingabeFeldStrasse.val();
				const hausnummer = self.eingabeFeldHausnummer.val();
				const plz = self.eingabeFeldPLZ.val();
				const ort = self.eingabeFeldOrt.val();
				if (quelle) {
					quelle.WhileTyping = true;
				}
				const loescheTimerUndFuehreAusAdresseGueltig = function () {
					adresseGueltigMitTimer.Timer = undefined;
					self._fuehreAusAdresseGueltig(self.adresseGueltigUrl, self.selectorWarnung, strasse, hausnummer, plz, ort);
				};
				adresseGueltigMitTimer.Timer = window.setTimeout(loescheTimerUndFuehreAusAdresseGueltig, 10);
			};
			self.eingabeFeldStrasse.attach(adresseGueltigMitTimer);
			self.eingabeFeldHausnummer.attach(adresseGueltigMitTimer);
			self.eingabeFeldPLZ.attach(adresseGueltigMitTimer);
			self.eingabeFeldOrt.attach(adresseGueltigMitTimer);
		};

		AdressCheck.prototype.eingabeFelder = function () {
			return [this.eingabeFeldStrasse, this.eingabeFeldHausnummer, this.eingabeFeldOrt, this.eingabeFeldPLZ];
		};

		AdressCheck.prototype._fuehreAusAdresseGueltig = function (adresseGueltigUrl, selectorWarnung, strasse, hausnummer, plz, ort) {
			const self = this;
			if (!strasse && !hausnummer && !plz && !ort) {
				$(selectorWarnung).children().remove();
				return;
			}
			ajaxHelper.nurEinRequest(
				adresseGueltigUrl,
				{
					strasse: strasse,
					hausnummer: hausnummer,
					plz: plz,
					ort: ort,
				},
				function (data) {
					if (selectorWarnung !== undefined) {
						// Fügt die Adressmeldungen in die Abo-Vorgänge ein:
						$(selectorWarnung).children().remove();
						let lis = '';
						if (data) {
							let letzteMeldung;
							for (let i = 0; i < data.length; ++i) {
								if (letzteMeldung === data[i].Meldung) {
									continue;
								}
								lis += `<li><label class = 'addresserror' style = 'display: inline'>${data[i].Meldung}</label></li>`;
								letzteMeldung = data[i].Meldung;
							}
						}
						$(selectorWarnung).prepend(lis);
					} else {
						// Fügt die Adressmeldungen in die Kundendatenmaske ein:
						$('.address-validation-error').remove();

						// invalid-CSS-Klasse von Feldern entfernen, wenn gefüllt:
						self.eingabeFelder().forEach(function (feld) {
							if (feld.$().val()) {
								feld.$().removeClass('is-invalid');
							}
						});

						if (data != null) {
							for (let i = 0; i < data.length; ++i) {
								let feldname;
								switch (data[i].AdresseGueltigErgebnis) {
									case AdresseGueltigErgebnis.FehlerStrasse:
										feldname = self.eingabeFeldStrasse.$()[0].id;
										break;
									case AdresseGueltigErgebnis.FehlerHausnummer:
										feldname = self.eingabeFeldHausnummer.$()[0].id;
										break;
									case AdresseGueltigErgebnis.FehlerOrt:
										feldname = self.eingabeFeldOrt.$()[0].id;
										break;
									case AdresseGueltigErgebnis.FehlerPLZ:
										feldname = self.eingabeFeldPLZ.$()[0].id;
										break;
								}
								if (feldname !== 'Ort') {
									// altes Design:
									const next = $(`.td-field-validation_${feldname}`);
									next.children().remove();
									next.prepend(`<span class='field-validation-error address-validation-error'>${data[i].Meldung}</span>`);
									// Bootstrap basiert:
									$(`#${feldname}`).addClass('is-invalid').next('.invalid-feedback').text(data[i].Meldung);
								}
							}
						}
					}
				}
			);
		};

		AdressCheck.prototype.AdresseGueltig = function () {
			const strasse = this.eingabeFeldStrasse.val();
			const hausnummer = this.eingabeFeldHausnummer.val();
			const plz = this.eingabeFeldPLZ.val();
			const ort = this.eingabeFeldOrt.val();
			if (strasse && hausnummer && plz && ort) {
				this.eingabeFeldStrasse.WhileTyping = true;
				this.eingabeFeldHausnummer.WhileTyping = true;
				this.eingabeFeldPLZ.WhileTyping = true;
				this.eingabeFeldOrt.WhileTyping = true;
			}
			this._fuehreAusAdresseGueltig(this.adresseGueltigUrl, this.selectorWarnung, strasse, hausnummer, plz, ort);
		};

		AdressCheck.prototype.StrasseSchreibweiseChecker = function (callback) {
			if (typeof callback !== 'function') {
				throw new Error('Der eingegebene Parameter ist keine gültige Funktion');
			}
			const self = this;
			const strasse = typeof this.eingabeFeldStrasse.val() == 'string' ? this.eingabeFeldStrasse.val().trim() : '';
			const plz = typeof this.eingabeFeldPLZ.val() == 'string' ? this.eingabeFeldPLZ.val().trim() : '';
			const ort = typeof this.eingabeFeldOrt.val() == 'string' ? this.eingabeFeldOrt.val().trim() : '';
			if (strasse !== '' && plz !== '' && ort !== '') {
				ajaxHelper.nurEinRequest(this.liefereStrassenUrl, { strasse, ort, plz }, function (data) {
					if (data.length > 0 && data.every(item => item.Strasse.toLowerCase().trim() !== strasse.toLowerCase())) {
						jjk.bootstrapModalHelper.message(`<div>Meinten Sie vielleicht eine dieser Straßen:</div> ${self._renderStrassenVorschlaege(data)}`, '', 'Hinweis', [
							{ text: 'Übernehmen', cssKlassen: 'btn-success uebernehmen' },
							{ text: 'Die von mir eingetragene Straße nutzen', cssKlassen: 'btn-light fortfahren' },
						]);
						const uebernehmen = document.querySelector('.btn-success.uebernehmen');
						uebernehmen.disabled = true;
						$('input[name=strassenvorschlaege]').on('click', () => {
							const gewaehlteStrasse = document.querySelector('input[name=strassenvorschlaege]:checked');
							if (gewaehlteStrasse !== null) {
								uebernehmen.disabled = false;
							}
						});

						$('.btn-success.uebernehmen').on('click', () => {
							document.getElementById('Strasse').value = document.querySelector('input[name=strassenvorschlaege]:checked').value;
							callback();
						});

						$('.btn-light.fortfahren').on('click', () => {
							callback();
						});
					} else {
						callback();
					}
				});
			} else {
				callback();
			}
		};

		AdressCheck.prototype._renderStrassenVorschlaege = function (data) {
			let result = '';
			for (const [index, item] of data.entries()) {
				result += `<label for="str${index}"><input type="radio" id="str${index}" name="strassenvorschlaege" value="${item.Strasse}"> ${item.Strasse}</lable><br>`;
			}
			return result;
		};

		return AdressCheck;
	})();
}
